import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import classes from "./MainFooterContactus.module.css";
import {
  AiFillMail,
  AiFillPhone,
  AiFillCaretDown,
  AiFillCaretUp,
} from "react-icons/ai";

const MainFooterContactus = () => {
  const [isContactUsShown, setIsContactUsShown] = useState(true);
  const browserWidth = useSelector((state) => state.browserData.browserWidth);

  useEffect(() => {
    if (browserWidth > 768) {
      setIsContactUsShown(true);
    }
  }, [browserWidth]);

  return (
    <div className={classes["main-footer-container__contact-us"]}>
      <div>
        <h2>Contact Us</h2>
        <span
          onClick={() => setIsContactUsShown((prev) => !prev)}
          className={classes["main-footer-container__contact-us__arrows"]}
        >
          {isContactUsShown ? <AiFillCaretUp /> : <AiFillCaretDown />}
        </span>
      </div>
      {isContactUsShown && (
        <>
          <h4>B And B International Trading Pvt Ltd</h4>
          <p>
            Corporate Office :Banasthali, Kathmandu Branch Office: Lakeside,
            Pokhara
          </p>
          <div>
            <p>
              <span className={classes.phone}>
                <AiFillPhone />
              </span>
              9856058166
            </p>
            <p>
              <span>
                <AiFillPhone />
              </span>
              9855010385
            </p>
            <p>
              <span>
                <AiFillMail />
              </span>
              bnbint6@gmail.com
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default MainFooterContactus;
